import React, { useState, useEffect, useRef } from 'react';
import Header from './LoginContent/HeaderLogin';
import styles from '../styles/Login.module.css';

import { loginUser } from '../firebaseConfig';
import { useHistory } from 'react-router-dom';
//import * as firebase from 'firebase/app';
//import LoginUser from './LoginContent/LoginUser';
//import RegisterUser from './LoginContent/RegisterUser';
//import Application from '../pages/Application';

import { getCurrentUser } from '../firebaseConfig';

const Login = () => {

    //const [logged, setLogged] = useState(true);
    //const [logUser, setLogUser] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLogged, setIsLogged] = useState(false);

    const history = useHistory();

    const isCurrent = useRef(true);

    useEffect(() => {
        return () => {
            isCurrent.current = false;
        }
    }, [])

    const onClickHandler = async () => {
        const res = await loginUser(username, password)
        if(res) {
            history.push('/Application')
            //window.history.replaceState({}, '', '/Application')
            //history.replace('/Application');
            console.log("You have logged in sucesfuly") // BIL TOAST
        } 
        console.log(res ? 'Login success' : 'Login failed');
    }
    useEffect(() => {
        getCurrentUser().then((user) => {
            if(user) {
                history.push('/Application')
                //setLogUser(user);
                console.log(user);
                if (isCurrent.current) { setIsLogged(true) }
            } else {
                history.push('/Login')
                console.log('no user back to -> /Login');
                if (isCurrent.current) { setIsLogged(false) }
            }
            //setBusy(false)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onReg = () => {
        history.push("/Register")
        console.log("onReg")
        //setLogged(false);
    }
    //const onLogHandler = () => {
    //    console.log("onLog")
        //setLogged(true);
    //}

    // const checkUser = () => {
    //     getCurrentUser().then((user) => {
    //         if(user) {
    //             console.log(user);
    //         } else {
    //             console.log(user);
    //             console.log("not connected")
    //         }
    //     })
    // }
    // const logOut = () => {
    //     logoutUser();
    //     console.log("Odjavili ste se!")
    // }
    // <RegisterUser onLog={onLogHandler} />

    return (
        <div className={styles.LoginUser}>
            
            <Header isLogged={isLogged} />
            
            <div className={styles.InLogin}>
                <div className={styles.Form}>
                    <p>Pozdravljeni</p>
                    <input
                        type='text'
                        placeholder='Uporabniško ime...'
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <input
                        type='password'
                        placeholder='Geslo...'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <button 
                        className={styles.ButtonLogin}
                        onClick={() => onClickHandler()}
                        >Prijavi se</button> 
                </div>
                <p>Novi Uporabnik? 
                    <button
                        className={styles.ButtonRegister}
                        onClick={onReg}
                        >Registriraj se
                    </button>
                </p>
                {
                //<button
                //    className={styles.ButtonRegister}
                //    onClick={() => checkUser()}>uporabnik?</button>
                //<button
                //    className={styles.ButtonRegister}
                //    onClick={() => logOut()}>Odjavi se</button>
                }
            </div>
        </div>
    );
}
  
export default Login;